export const DEMO_CONSENT_CHILDREN = [
  { name: 'Sofie Eksempel', cpr: '0202020202' },
  { name: 'Noah Eksempel', cpr: '0707070707' }
] as const;

export type DemoConsentChild = typeof DEMO_CONSENT_CHILDREN[number];
